import { Link, useLocation, useNavigate } from 'react-router-dom';
import { navItems, site } from '../content';
import { cx } from '../lib/cx';
import Logo from './Logo';

function scrollToSection(sectionId, immediate, rate) {
  const target = document.getElementById(sectionId);
  if (!target) {
    return;
  }
  const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
  const distance = Math.abs(targetTop - window.pageYOffset);
  let duration = Math.max(300, Math.min(2000, 120 + distance * 0.2));
  if (typeof rate === 'number' && rate > 0) {
    duration *= rate;
  }
  if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.scrollTo(0, targetTop);
    return;
  }
  const start = window.pageYOffset;
  const startTime = performance.now();
  function frame(now) {
    const t = Math.min(1, (now - startTime) / duration);
    const eased = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    window.scrollTo(0, start + (targetTop - start) * eased);
    if (t < 1) {
      window.requestAnimationFrame(frame);
    }
  }
  window.requestAnimationFrame(frame);
}

export function getSectionIdFromTo(to) {
  try {
    const url = new URL(to, 'https://mustimpress.com');
    return url.searchParams.get('section');
  } catch (err) {
    return null;
  }
}

export default function Header({ navOpen, onToggleNav, onCloseNav, fade }) {
  const location = useLocation();
  const navigate = useNavigate();

  function handleNavClick(event, to) {
    const sectionId = getSectionIdFromTo(to);
    onCloseNav();
    if (!sectionId) {
      return;
    }
    if (location.pathname === '/') {
      event.preventDefault();
      navigate(to, { replace: true });
      scrollToSection(sectionId, false);
    }
  }

  return (
    <>
      <nav id="nav-primary">
        <ul className="nav list-none p-0 m-0">
          {navItems.map((item) => (
            <li key={item.label}>
              <Link to={item.to} onClick={(event) => handleNavClick(event, item.to)}>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <header id="header">
        <div className="contain container-fluid container-limit">
          <div className="flex flex-wrap justify-between">
            <div className="logo-wrapper shrink-0">
              <Link to="/" className="logo-link" aria-label={site.name} onClick={onCloseNav}>
                <Logo />
              </Link>
            </div>
            <div id="nav-toggle-wrapper" className="w-auto">
              <a
                href="#nav-primary"
                id="nav-toggle"
                className={cx(navOpen && 'active')}
                onClick={(event) => {
                  event.preventDefault();
                  onToggleNav();
                }}
              >
                <span className="wrap">
                  <span style={{ background: 'var(--color-highlight, var(--color-primary))' }} />
                  <span style={{ background: 'var(--color-highlight, var(--color-primary))' }} />
                  <span style={{ background: 'var(--color-highlight, var(--color-primary))' }} />
                </span>
              </a>
            </div>
          </div>
        </div>
        {fade ? <div className="fade show" /> : null}
      </header>
    </>
  );
}

export { scrollToSection };
